import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
    {
        path: "/work",
        name: "Home",
        component: Home,
    },
    {
        path: "/work/:slug",
        name: "Work",
        component: () =>
            import(/* webpackChunkName: "home" */ "../views/Work.vue"),
    },
    {
        path: "/about",
        name: "About",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/About.vue"),
    },
    {
        path: "/",
        name: "Intro",
        component: () =>
            import(/* webpackChunkName: "intro" */ "../views/Intro.vue"),
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
